import HomeBanner from 'src/pages/home/components/cards/HomeBanner';
import RewardCard from '../../components/common/cards/RewardCard';
import RecentActivityCard from '../../components/common/cards/RecentActivityCard';
import IconSvg from 'src/components/common/ui/IconSvg';
import Slider, { CustomArrowProps, Settings } from 'react-slick';
import './Home.module.css';
import {
  rewardCardData,
  recentActivityData,
  homeBannerData as initialHomeBannerData,
  HomeBannerData,
} from 'src/dummydata';

import { useEffect, useState } from 'react';
import { Collection } from 'src/components/common/cards/types/types';
import { useHttp } from 'src/hooks';
import HomePlayItem from './components/HomePlayItem';
import HomeEarnItem from './components/HomeEarnItem';
import {useAccount, useSwitchChain} from 'wagmi';
import { ethers } from 'ethers';


const environment = process.env.REACT_APP_ENVIRONMENT;

function CustomArrow(props: CustomArrowProps & { additionalStyles?: React.CSSProperties }) {
  const { className, style, onClick, additionalStyles } = props;
  return (
    <IconSvg
      icon={className?.includes('slick-next') ? 'arrowRightM' : 'arrowLeftM'}
      className={`text-brand-primary-light hover:!text-brand-primary-light !w-6 !h-6 ${className}`}
      onClick={onClick}
      style={{ ...style, ...additionalStyles }}
    />
  );
}

function getSliderSettings(
  slidesToShow: number,
  breakpoints: { [key: number]: number },
  customArrows?: boolean,
): Settings {
  const responsiveSettings = Object.entries(breakpoints).map(([breakpoint, slides]) => ({
    breakpoint: Number(breakpoint),
    settings: {
      slidesToShow: slides,
    },
  }));

  return {
    infinite: true,
    slidesToShow,
    autoplay: true,
    autoplaySpeed: 3000,
    // autoplay: true,
    slidesToScroll: 1,
    nextArrow: <CustomArrow additionalStyles={customArrows ? { right: '40px', zIndex: 50 } : {}} />,
    prevArrow: <CustomArrow additionalStyles={customArrows ? { left: '40px', zIndex: 50 } : {}} />,
    responsive: responsiveSettings,
    dots: customArrows,
    appendDots: customArrows
      ? (dots: React.ReactNode) => <ul style={{ bottom: '41.5px', lineHeight: '0px' }}>{dots}</ul>
      : undefined,
    customPaging: customArrows
      ? () => (
          <div className="dot-container">
            <svg
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="dot-svg"
            >
              <rect x="2" y="2" width="8" height="8" fill="#ADADAD" className="filled-dot" />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.5 1.5H2.5H9.5H10.5V10.5H9.5H2.5H1.5V1.5ZM9.5 9.5V2.5H2.5V9.5H9.5Z"
                fill="#ADADAD"
                className="empty-dot"
              />
            </svg>
          </div>
        )
      : undefined,
  };
}

function Home() {
  const [activeTab, setActiveTab] = useState('all');
  const [arenaTotalMintedKeys, setArenaTotalMintedKeys] = useState('');
  const { sendRequest } = useHttp();
  const [collections, setCollections] = useState<Collection[]>([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [homeBannerData, setHomeBannerData] = useState<HomeBannerData[]>(initialHomeBannerData);
  const {address, isConnected} = useAccount();
  useEffect(() => {
    getCollections();
  }, [activeTab]);

  useEffect(() => {
    if(address && isConnected && collections?.length > 0)
      readMintedKeyEvents();

  }, [address, isConnected, collections])

  const tabs: { value: string; label: string }[] = [
    { value: 'all', label: 'All projects' },
    {
      value: 'live',
      label: 'Live',
    },
    {
      value: 'soon',
      label: 'Soon',
    },

    {
      value: 'expired',
      label: 'Expired',
    },
  ];

  const sliderSettings1 = getSliderSettings(7, {
    2500: 6,
    2200: 5,
    1850: 4,
    1500: 3,
    1200: 2,
  });

  const sliderSettings3 = getSliderSettings(1, {}, true);

  const getCollections = () => {
    sendRequest(
      {
        url: 'collections',
        method: 'GET',
      },
      (data: any) => {
        setCollections(data);

        for (const banner of initialHomeBannerData) {
          const matchedCollection = data.filter((collection: any) => {
            if (collection.slug === banner.slug) {
              return collection;
            }
          });

          const stageId = matchedCollection[0].stages?.filter(st => st.isLive);
          if (matchedCollection[0]) {
            banner.id = matchedCollection[0].id;
            banner.stageId = stageId.length ? stageId[0].id : null;
          }
        }

        setHomeBannerData(initialHomeBannerData);
      },
    );
  };

  let filteredCollectionsEarn = collections.filter(collection => {
    if (activeTab === 'all') return true; // Show all projects
    if (activeTab === 'live') return collection.status === 'Live';
    if (activeTab === 'soon') return collection.status === 'Soon';
    if (activeTab === 'expired') return collection.status === 'Expired';
    return false;
  });
  if (searchQuery)
    filteredCollectionsEarn = filteredCollectionsEarn.filter(
      collection =>
        collection.name.toLowerCase().includes(searchQuery.toLowerCase()) &&
        !collection.isEarnBlured,
    );

  let filteredCollectionsPlay = collections.filter(collection => {
    if (activeTab === 'all') return true; // Show all projects
    if (activeTab === 'live') return collection.status === 'Live' && !collection.isPlayBlured;
    if (activeTab === 'soon') return collection.status === 'Soon';
    if (activeTab === 'expired') return collection.status === 'Expired';
    return false;
  });
  if (searchQuery)
    filteredCollectionsPlay = filteredCollectionsPlay.filter(
      collection =>
        collection.name.toLowerCase().includes(searchQuery.toLowerCase()) &&
        !collection.isPlayBlured,
    );

  const readMintedKeyEvents = async () => {
    try {
      const arenaCollection = collections.filter(collection => collection.slug == 'arena')[0];
      const phase1Config = arenaCollection?.stages?.filter(stage => stage.order === 1)[0]?.metadata[environment]; // right now just for arena
      if (!phase1Config) return;

      const provider = new ethers.providers.JsonRpcProvider(arenaCollection?.network.RPCUrl);
      // const provider = new ethers.providers.JsonRpcProvider(
      //   `https://eth-sepolia.g.alchemy.com/v2/7HTsUbq3GedSAO_HZ2cswYr2vcJ9W6DP`
      // );
      // const provider = new ethers.providers.JsonRpcProvider(
      //   `https://base-sepolia.g.alchemy.com/v2/EnacGRWAvwYnhx_Vd4e6y6Q4wfafzxMg`
      // );
      // const provider = new ethers.providers.JsonRpcProvider(
      //   `https://avax-fuji.g.alchemy.com/v2/irtyiHXuwACSy69kigixjG-pJkVpxiL0`
      // );
      // const provider = new ethers.providers.JsonRpcProvider(
      //   `https://avax-mainnet.g.alchemy.com/v2/irtyiHXuwACSy69kigixjG-pJkVpxiL0`
      // );

      const contract1 = new ethers.Contract(phase1Config.LOOTY_KEY.address, phase1Config.LOOTY_KEY.abi, provider);
      const eventFilter = contract1.filters.TransferSingle(null, "0x0000000000000000000000000000000000000000");
      const fromBlock = 1;
      const toBlock = 'latest';

      const events = await contract1.queryFilter(eventFilter, fromBlock, toBlock);

      console.log('eeeeeee', events)
      const mintedKeys = events.reduce((sum, event) => {
        const ev: any = event;
        console.log('readMintedKeyEvents-> Internal:',  ev?.args?.value.toNumber());
        return sum + event?.args?.value.toNumber();
      }, 0);
      console.log('readMintedKeyEvents-> Total Minted Keys:', mintedKeys);
      setArenaTotalMintedKeys(mintedKeys);
    } catch (error) {
      console.error("Error initializing event listener:", error);
    }
  };
    
  return (
    <>
      <section className="mb-[72px]">
        <div className="min-w-0 min-h-0 mx-auto max-w-[2630px]">
          <Slider {...sliderSettings3}>
            {homeBannerData.map((data, index) => (
              <HomeBanner
                key={index}
                bannerImg={data.image}
                btnText={data.btnText}
                title={data.title}
                slug={data.slug}
                status={data.status}
                collectionImage={data.collectionImage}
                id={data?.id}
                stageId={data?.stageId}
                website={data.website}
                twitter={data.twitter}
                projectType={data.projectType}
                showButtons={data.showButtons}
                arenaTotalMintedKeys={arenaTotalMintedKeys}
              />
            ))}
          </Slider>
        </div>
      </section>

      <section className="mb-[72px]">
        <div className="flex items-end justify-between mb-[72px]">
          <div>
            <h1 className="uppercase mb-[19px] text-brand-primary-light">
              We only <span className="text-brand-primary">Win</span>!
            </h1>

            <p className="text-lg text-grayscale-200">
              Get keys. Trade keys. Open lootboxes. Win rewards.
            </p>
          </div>

          <div className="flex gap-6">
            <div>
              <div className="mb-2 text-sm text-grayscale-400 text-end">Total Winnable Rewards</div>
              <div className="text-lg font-semibold text-grayscale-100 text-end">≈ $370,000</div>
            </div>

            {/* <div className="border-l-2 h-[59px] border-grayscale-700"></div>

            <div>
              <div className="mb-2 text-sm text-grayscale-400 text-end">Total Minted Keys</div>
              <div className="text-lg font-semibold text-grayscale-100 text-end">1,991</div>
            </div>

            <div className="border-l-2 h-[59px] border-grayscale-700"></div>

            <div>
              <div className="mb-2 text-sm text-grayscale-400 text-end">Total Rewards Won</div>
              <div className="text-lg font-semibold text-grayscale-100 text-end">445</div>
            </div> */}
          </div>
        </div>

        <div className="flex items-center justify-between px-5 py-3 mb-10 rounded-md bg-grayscale-800">
          <div className="flex gap-2">
            {tabs.map(tab => (
              <div
                key={tab.value}
                onClick={() => setActiveTab(tab.value)}
                className={`px-4 py-2 rounded cursor-pointer select-none ${
                  activeTab === tab.value ? 'bg-grayscale-600' : ''
                }`}
              >
                <div
                  className={`text-sm font-semibold ${
                    activeTab === tab.value ? 'text-grayscale-200' : 'text-gray-300'
                  }`}
                >
                  {tab.label}
                </div>
              </div>
            ))}
          </div>

          <div className="relative">
            <input
              type="search"
              placeholder="Search"
              className="w-[309px] bg-grayscale-900 text-grayscale-200 placeholder:text-grayscale-600 pl-9 py-2 text-sm relative rounded-md pr-3"
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
            />

            <IconSvg
              icon="searchS"
              className="absolute inset-y-0 m-auto left-4 text-grayscale-300"
            />
          </div>
        </div>

        <div className="grid w-full gap-y-8 gap-x-5 3xl:grid-cols-2">
          <div className="col-span-1">
            <div className="text-2xl font-bold text-grayscale-300 mb-2.5">Earn</div>
            {filteredCollectionsEarn.length === 0 ? (
              <div
                className={`px-5 py-[15px] rounded-md items-center bg-grayscale-800 h-[90px] flex`}
              >
                <h5 className="text-brand-primary-light">No projects found</h5>
              </div>
            ) : (
              <>
                {filteredCollectionsEarn
                  .filter(collection => !collection.isEarnBlured)
                  .map((collection, index) => (
                    <HomeEarnItem arenaTotalMintedKeys={arenaTotalMintedKeys} collection={collection} key={index} handleClick={() => ''} />
                  ))}

                {filteredCollectionsEarn
                  .filter(collection => collection.isEarnBlured)
                  .slice(0, 2)
                  .map((collection, index) => (
                    <HomeEarnItem
                      key={index}
                      index={index + 1}
                      collection={collection}
                      handleClick={() => ''}
                      arenaTotalMintedKeys={arenaTotalMintedKeys}
                    />
                  ))}
              </>
            )}
          </div>
          <div className="col-span-1">
            <div className="text-2xl font-bold text-grayscale-300 mb-2.5">Play</div>

            {/* <div
              className={`px-5 py-[15px] rounded-md items-center bg-grayscale-800 h-[90px] flex`}
            >
              <h5 className="text-brand-primary-light">No projects found</h5>
            </div> */}

            {filteredCollectionsPlay.length === 0 ? (
              <img src="/assets/images/coming-soon.png" className="h-full" />
            ) : (
              <>
                <img src="/assets/images/coming-soon.png" className="h-full" />

                {/* {filteredCollectionsPlay
                  .filter(collection => collection.isPlayBlured)
                  .slice(
                    0,
                    filteredCollectionsEarn.filter(collection => !collection.isEarnBlured).length +
                      2,
                  )
                  .map((collection, index) => (
                    <HomePlayItem collection={collection} key={index} handleClick={() => ''} />
                  ))}

                {filteredCollectionsPlay
                  .filter(collection => !collection.isPlayBlured)
                  .map((collection, index) => (
                    <HomePlayItem collection={collection} key={index} handleClick={() => ''} />
                  ))} */}
              </>
            )}
          </div>
        </div>
      </section>

      <section className="mb-[72px]">
        <div className="mb-12">
          <h2 className="uppercase mb-[19px] text-brand-primary-light">
            <span className="text-brand-primary">Hot</span> Rewards
          </h2>

          <p className="text-grayscale-200 max-w-[1255px] text-lg">
            Our top rewards celebrate exceptional achievements, offering unique digital collectibles
            and unforgettable real-life experiences. Browse through the latest claimed rewards. Join
            our community of winners and claim your hot rewards!
          </p>
        </div>

        <div className="min-w-0 min-h-0 mx-auto max-w-[2630px]">
          <Slider {...sliderSettings1}>
            {rewardCardData.map((card, index) => (
              <div key={index} className="!block mx-auto !w-fit">
                <RewardCard
                  name={card.name}
                  estimatedValue={card.estimatedValue}
                  rarity={card.rarity}
                  image={card.image}
                />
              </div>
            ))}
          </Slider>
        </div>
      </section>

      <section>
        <div className="mb-12">
          <h2 className="uppercase mb-[19px] text-brand-primary-light">
            Recent <span className="text-brand-primary">Activities</span>
          </h2>

          <p className="text-grayscale-200 max-w-[895px] text-lg">
            Track newly minted keys and opened boxes in real-time. Our live feed will guide you to
            optimize your strategy for minting and loot box openings.
          </p>
        </div>

        <div className="min-w-0 min-h-0 mx-auto max-w-[2630px]">
          <Slider {...sliderSettings1}>
            {recentActivityData.map((activity, index) => (
              <div className="!block mx-auto !w-fit" key={index}>
                <RecentActivityCard
                  projectName={'Project Name'}
                  estimatedValue={activity.estimatedValue}
                  rewardOpened={activity.rewardOpened}
                  image={activity.image}
                  activity={activity.projectName}
                />
              </div>
            ))}
          </Slider>
        </div>
      </section>
    </>
  );
}

export default Home;
